import React, { useState, useEffect, Fragment } from "react";
import { Table, Col, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { NominationTableViewBody } from "../NominationAllTable/NominationTableViewBody";
import BasicPagination from "../../../../Pagination/Pagination";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { viewNominationsByRestaurantId } from "../../../../../store/actions/SuperAdminActions/commonSuperAdmin";
import moment from "moment";
import { useParams } from "react-router-dom";

const SuperAdminNominatioViewPage = (props) => {
  const { viewIndex } = useParams();
  const renderTableDataBody = (nomination) => {
    return (
      <React.Fragment>
        {console.log("nomination ===>", nomination)}
        <NominationTableViewBody
          // userImage={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
          // userImage={
          //   nomination?.user?.profile_photo[0]
          //     ? nomination?.user?.profile_photo[0]
          //     : require("../../../../../assets/images/ActionImages/demoprofile.jpg")
          // }
          userName={nomination?.user?.first_name}
          userDate={moment(nomination?.time).format("DD-MM-YYYY")}
          userTime={moment(nomination?.time).format("LT")}
          status={nomination?.status ? <> Yes </> : <>No </>}
        />
      </React.Fragment>
    );
  };
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onSuccessNominations = () => {
    setLoading(false);
  };
  const onErrorNominations = () => {
    setLoading(false);
  };
  // useEffect(() => {
  //   setLoading(true);
  //   const token = props.auth.user.accessToken;
  //   props.viewNominationsByRestaurantId(
  //     token,
  //     onSuccessNominations,
  //     onErrorNominations
  //   );
  // }, []);
  return (
    <React.Fragment>
      {!loading ? (
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation
                backIcon={true}
                displayText="Back"
                link="/superadminnomination"
              />
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-5">
                    <Col className="pt-4 pb-3">
                      {/* <NavLink
                        to="/superadminnomination"
                        className="f12-500 enBackLink"
                      >
                        <Image
                          fluid
                          alt="Back Icon"
                          title="Back Icon"
                          className="mr-2"
                          src={require("../../../../../assets/images/UserManagement/backIcon.svg")}
                        />
                        Back
                      </NavLink> */}
                      <div className="f24_700_HelveticaNeue">
                        Nomination Details for Restaurant
                      </div>
                      <div className="f14-500 my-5 d-flex">
                        Google Place ID:{" "}
                        <p className="f13-400 pl-2">
                          {props.allRestaurantNominations &&
                            props.allRestaurantNominations.data &&
                            props.allRestaurantNominations.data[viewIndex]
                              .place_id}
                        </p>
                      </div>

                      <div className="d-flex mt-4 enShadowBox emMaxWidth330px p-0 text-break">
                        <div className="enFRLogoBox">
                          <div className="enlogo">
                            <Image
                              // src={require("../../../../../assets/images/superadmin/streetmeat.png")}
                              src={
                                props.allRestaurantNominations &&
                                props.allRestaurantNominations.data &&
                                props.allRestaurantNominations.data[viewIndex]
                                  .icon
                              }
                              alt="res pic"
                              title="res Pic"
                              fluid
                            />
                          </div>
                          <div className="d-flex align-items-start pt-2">
                            <Image
                              src={require("../../../../../assets/images/superadmin/star.svg")}
                              alt="Profile pic"
                              title="Profile Pic"
                              width="10px"
                              className="mt-2"
                            />
                            <div className="pl-1">
                              <div className="f14-700">
                                {props.allRestaurantNominations &&
                                  props.allRestaurantNominations.data &&
                                  props.allRestaurantNominations.data[viewIndex]
                                    .rating}
                              </div>
                              <div className="f9-400">
                                {props.allRestaurantNominations &&
                                  props.allRestaurantNominations.data &&
                                  props.allRestaurantNominations.data[viewIndex]
                                    .user_ratings_total}{" "}
                                reviews
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="w-100">
                          <div className="f16-700 pl-3 pt-3">
                            {" "}
                            {props.allRestaurantNominations &&
                              props.allRestaurantNominations.data &&
                              props.allRestaurantNominations.data[viewIndex]
                                .name}
                          </div>
                          <div className="d-flex flex-wrap border-bottom">
                            <div className="d-flex align-items-start p-3">
                              <Image
                                src={require("../../../../../assets/images/UserManagement/filter.svg")}
                                alt="Profile pic"
                                title="Profile Pic"
                                width="13px"
                                className="mt-1"
                              />
                              <div className="pl-1">
                                <div className="f13-700">
                                  {props?.allRestaurantNominations?.data[
                                    viewIndex
                                  ]?.types.toLocaleString()}
                                </div>
                                {console.log(
                                  props.allRestaurantNominations &&
                                    props.allRestaurantNominations.data &&
                                    props.allRestaurantNominations.data[
                                      viewIndex
                                    ].types.toLocaleString()
                                )}
                                <div className="f9-400">Fine Dining</div>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-start p-3">
                            <Image
                              src={require("../../../../../assets/images/UserManagement/clock-red.svg")}
                              alt="Profile pic"
                              title="Profile Pic"
                              width="12px"
                            />
                            <div className="pl-1">
                              <div className="f13-700">
                                {props?.allRestaurantNominations?.data[
                                  viewIndex
                                ].opening_hours?.open_now
                                  ? "Open"
                                  : "Closed"}
                              </div>
                              <div className="f9-400 text-gray">Opens At</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-5 mb-4 d-flex align-items-center">
                        <div className="f14-500">Location:&nbsp;</div>
                        <div className="f14-400">
                          {" "}
                          {props.allRestaurantNominations &&
                            props.allRestaurantNominations.data &&
                            props.allRestaurantNominations.data[viewIndex]
                              .vicinity}
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="f14-500">City:&nbsp;</div>
                        <div className="f14-400">
                          {props.allRestaurantNominations &&
                            props.allRestaurantNominations.data &&
                            props.allRestaurantNominations.data[
                              viewIndex
                            ].vicinity
                              .split(" ")
                              .slice(-1)[0]}
                        </div>
                      </div>
                    </Col>
                  </div>
                  <div className="enBgGray enMinHeight100vh col-lg-7">
                    <div className="user-table-reusable-superadmin table-responsive">
                      <Table className="enMinWidth500 HideShowTable">
                        <thead>
                          <tr className="super_admin_all_users_table_head">
                            <th className="f12-500" style={{ width: "40%" }}>
                              User Name
                            </th>
                            <th className="f12-500" style={{ width: "30%" }}>
                              Date - Time
                            </th>
                            <th className="f12-500" style={{ width: "30%" }}>
                              Status
                            </th>
                          </tr>
                        </thead>
                        {props.allRestaurantNominations &&
                          props.allRestaurantNominations.data &&
                          props.allRestaurantNominations.data[
                            viewIndex
                          ].nomination
                            .slice(start, end)
                            .map((nomination, index) => (
                              <Fragment key={index}>
                                {renderTableDataBody(nomination)}
                              </Fragment>
                            ))}
                      </Table>
                    </div>
                    {props.allRestaurantNominations &&
                    props.allRestaurantNominations.data &&
                    props.allRestaurantNominations.data[viewIndex].nomination
                      .length !== 0 ? (
                      <BasicPagination
                        totalRecords={
                          props.allRestaurantNominations &&
                          props.allRestaurantNominations.data &&
                          props.allRestaurantNominations.data[viewIndex]
                            .nomination.length
                        }
                        limit={10}
                        batch={page}
                        onBatchChange={(e) => handleBatchChange(e)}
                      />
                    ) : (
                      <> </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <AmealioLoader />
      )}
    </React.Fragment>
  );
};

SuperAdminNominatioViewPage.propTypes = {
  auth: PropTypes.object.isRequired,
  viewNominationsByRestaurantId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allRestaurantNominations: state.commonSuperAdmin.allRestaurantNominations,
});

export default connect(mapStateToProps, {
  viewNominationsByRestaurantId,
})(SuperAdminNominatioViewPage);
